/* ============================================================
   Watch Reserves — cart drawer line controls.

   Same pattern as wr-cart.js (the full /cart page): quantity and remove
   go through /cart/change.js and re-render this one section via Shopify's
   Section Rendering API. Kept as a separate script/section id
   (wr-cart-drawer-section, data-wr-drawer-cart-root) so it never collides
   with wr-cart.js's own section when both are on the page at once — the
   drawer is global, so that includes the /cart page itself.

   Delegated from document rather than bound per button: the drawer's
   content is also replaced wholesale after an add-to-cart (see wr-pdp.js /
   wr-collection.js), which would otherwise leave freshly-swapped-in buttons
   with no listeners until this file rebound them itself.
   ============================================================ */
(function () {
  'use strict';

  var SECTION_ID = 'wr-cart-drawer-section';
  var busy = false;

  function showError(message) {
    var box = document.querySelector('[data-wr-cart-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
    if (message) setTimeout(function () { box.hidden = true; }, 5000);
  }

  function updateCartBadge(count) {
    var link = document.querySelector('[data-wr-cart-link]');
    if (!link) return;
    var badge = link.querySelector('[data-wr-cart-count]');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'wr-cart-badge';
      badge.setAttribute('data-wr-cart-count', '');
      link.appendChild(badge);
    }
    if (count === 0 && badge) badge.remove();
    else if (badge) badge.textContent = count > 9 ? '9+' : String(count);
  }

  function restoreFocus(focusLine, focusTo) {
    if (!focusLine) return;
    var line = document.querySelector('[data-wr-line="' + focusLine + '"]');
    if (!line) return;
    var buttons = line.querySelectorAll('[data-wr-drawer-qty]');
    var target = null;
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].dataset.wrDrawerTo === focusTo) { target = buttons[i]; break; }
    }
    (target || buttons[0] || line).focus();
  }

  function change(line, quantity, lineEl) {
    if (busy) return;
    busy = true;
    if (lineEl) lineEl.classList.add('is-busy');

    /* The section swap replaces the pressed button, dropping focus to the
       document — a keyboard user would re-tab from the top after every
       +/- (WCAG 2.4.3). Remember the control so it can be re-focused. */
    var activeEl = document.activeElement;
    var focusLine = activeEl && activeEl.dataset ? activeEl.dataset.wrDrawerQty : null;
    var focusTo = activeEl && activeEl.dataset ? activeEl.dataset.wrDrawerTo : null;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: SECTION_ID })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      })
      .then(function (cart) {
        updateCartBadge(cart.item_count);

        var html = cart.sections && cart.sections[SECTION_ID];
        var host = document.getElementById('shopify-section-' + SECTION_ID);
        if (!html || !host) {
          window.location.reload();
          return;
        }
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('shopify-section-' + SECTION_ID);
        host.innerHTML = fresh ? fresh.innerHTML : parsed.body.innerHTML;
        restoreFocus(focusLine, focusTo);
        if (window.wrAnnounce) window.wrAnnounce('Cart updated.');
      })
      .catch(function () {
        showError("We couldn't update your cart. Please try again.");
        if (lineEl) lineEl.classList.remove('is-busy');
      })
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wr-drawer-qty]');
    if (!btn) return;
    var line = Number(btn.dataset.wrDrawerQty);
    var to = Number(btn.dataset.wrDrawerTo);
    if (to < 0) return;
    change(line, to, btn.closest('.wr-line'));
  });

  /* ── Confirmation pane ──────────────────────────────────────────
     Two views share one dialog: the add-to-cart confirmation (just the
     piece added) and the full cart (opened from the header icon). Which
     one shows is the .is-confirm class; these helpers are exposed on
     window so wr-pdp.js and wr-collection.js can drive them without each
     re-implementing it. */

  function money(cents) {
    // Matches money_without_trailing_zeros used across the cart: whole
    // dollars drop the .00, anything else keeps two places.
    var v = (Number(cents) || 0) / 100;
    var s = v % 1 === 0 ? String(v) : v.toFixed(2);
    var code = window.Shopify && Shopify.currency && Shopify.currency.active;
    // Non-USD markets get the ISO code, matching snippets/wr-money.liquid.
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (code && code !== 'USD' ? ' ' + code : '');
  }

  function setText(sel, value) {
    var el = document.querySelector(sel);
    if (el) el.textContent = value || '';
  }

  window.wrShowCartConfirm = function (item, itemCount) {
    var dialog = document.getElementById('cart-drawer');
    if (!dialog || !item) return false;

    var img = document.querySelector('[data-wr-confirm-img]');
    if (img) {
      // Cart line images come back without a scheme sometimes, and at full
      // size; ask for a small square instead of shipping a 2000px file.
      var src = item.image || '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      if (src) src = src.replace(/(\.(?:jpg|jpeg|png|webp))(\?.*)?$/i, '_160x160$1');
      img.src = src;
      img.alt = item.product_title || item.title || '';
      img.style.display = src ? '' : 'none';
    }

    setText('[data-wr-confirm-vendor]', item.vendor);
    setText('[data-wr-confirm-title]', item.product_title || item.title);

    var variant = item.variant_title;
    var vEl = document.querySelector('[data-wr-confirm-variant]');
    if (vEl) {
      var show = variant && variant.indexOf('Default Title') === -1;
      vEl.textContent = show ? variant : '';
      vEl.style.display = show ? '' : 'none';
    }

    setText('[data-wr-confirm-price]', money(item.final_line_price != null ? item.final_line_price : item.price));
    setText('[data-wr-confirm-count]', String(itemCount != null ? itemCount : ''));

    dialog.classList.add('is-confirm');
    if (!dialog.open) dialog.showModal();
    return true;
  };

  window.wrShowCartFull = function () {
    var dialog = document.getElementById('cart-drawer');
    if (!dialog) return;
    dialog.classList.remove('is-confirm');
    if (!dialog.open) dialog.showModal();
  };

  // "View Cart" swaps to the full cart in place rather than navigating —
  // the markup is already in the dialog and kept current by the section
  // swap on every add.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-wr-view-cart]')) return;
    window.wrShowCartFull();
  });

  // Close is a native <form method="dialog"> submit — no JS needed for
  // that. This just adds the click-outside-to-close convenience showModal()
  // doesn't provide natively.
  var dialog = document.getElementById('cart-drawer');
  if (dialog) {
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
  }

  // The header cart icon opens the popup instead of navigating to /cart.
  // It stays a real <a href="/cart"> in the markup, so it still works
  // without JS and a crawler can follow it; this only intercepts an
  // ordinary left click. Modifier and middle clicks fall through so
  // "open in new tab" keeps working. On the /cart template the drawer is
  // never rendered, so `dialog` is null there and the link navigates as
  // usual.
  document.addEventListener('click', function (e) {
    if (!dialog) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var link = e.target.closest('[data-wr-cart-link]');
    if (!link) return;

    e.preventDefault();
    window.wrShowCartFull();
  });
})();
